const theme = {
  light: {
    background: '#F2F2F2',
    backgroundSecondary: '#304673',
    textPrimary: '#F2F2F2',
    textSecondary: '#0D0D0D',
    textTertiary: '#304673',
    buttonPrimary: '#F2DD72',
    buttonSecondary: '#F2EE72',
    buttonGhost: 'transparent',
  },
  dark: {
    background: '#0D0D0D',
    backgroundSecondary: '#304673',
    textPrimary: '#0D0D0D',
    textSecondary: '#F2F2F2',
    textTertiary: '#F2F2F2',
    buttonPrimary: '#F2DD72',
    buttonSecondary: '#F2EE72',
    buttonGhost: 'transparent',
  },
}

export default theme
